import React from 'react';
import EventEmitter from '../../../utils/emmiter';
import {UserContext} from '../../../utils/usercontext';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../fontawesome/fontawesome';

import Waveform from 'react-audio-waveform';

import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

export default class AudioPlayer extends React.Component {
	static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
      
			audio: this.props.audio,
			
			AudioListener: null,

    };

		const AudioListener = EventEmitter.addListener('/audio/player', data => {
			//socket.current.emit("/admin/chatbox/disconnect", data );
		}); this.setState({AudioListener});

		this.audioPlay = this.audioPlay.bind(this);
		this.displayTime = this.displayTime.bind(this);
		
  };

  // Instantiate a Video.js player when the component mounts
  componentDidMount() {
    
  }

  // Dispose the player when the component will unmount
  componentWillUnmount() {
		if( this.state.AudioListener) this.state.AudioListener.remove();
  }

	componentDidCatch() {
		//throw new Error("An error has occured in a very Buggy component!");
	}

	audioSender(command, options) {
		EventEmitter.emit('/audio/player', {command, options});
	}

	async audioReceiver() {

	}

	audioPlay(id) {
		this.audioSender('play', {id})
	}

	displayTime(time) {
		var date = new Date(null);
		date.setSeconds(time); // specify value for SECONDS here
		var result = date.toISOString().substr(11, 8);
		return result;
	}


  render() {
    return (
      <div className="row">
				<div className="p-schedule-event-audio p-0" style={{width: 120, textAlign: 'center'}}>
					<img src={this.state.audio.schedule?.avatar} width="114" height="114" alt="profile avatar" />
				</div>
				<div className="col">
					<div className="row">
						<div className="col-12 py-1" style={{fontSize:14, color: '#ffffff'}}>
							{this.state.audio.showname.length>0?this.state.audio.showname:'SHOWNAME'}
						</div>
						<div className="col-12" style={{height:50, borderBottom: '1px solid #5e0534', position: 'relative'}}>
							<div className="p-scheule-event-wavestart">
								0:00:00
							</div>
							<div className="p-scheule-event-waveform px-0" style={{paddingTop: 0}}>
								<Waveform
									barWidth={2}
									peaks={this.state.audio.waveform.data}
									height={50}
									onClick={this.handleClick}
									color="#676767"
									progressGradientColors={[[0, "#888"], [1, "#aaa"]]}
								/>
							</div>
							<div className="p-scheule-event-waveend">
								{this.displayTime(this.state.audio.length)}
							</div>
						</div>
						<div className="col-12">
							<div className="row">
								<div className="audio-cursor" style={{width:30, marginTop: 3}} onClick={()=>this.audioPlay(this.state.audio.id)}>
									<OverlayTrigger key="play" placement="top" overlay={
											<Tooltip id="tooltip-play">Play Track</Tooltip>
										}><FontAwesomeIcon icon="play" style={{fontSize: 18, paddingTop: 6}} />
									</OverlayTrigger>
								</div>
								<div className="col">
									<div style={{fontSize: 12, marginTop: 3}}>
										{this.state.audio.schedule?.genres&&this.state.audio.schedule.genres.length > 0 &&
											Object.keys(this.state.audio.schedule.genres).map((f,j) => {
												return (
													<span key={j} style={{margin: 3, paddingTop: 5, paddingRight: 10, paddingBottom: 5, paddingLeft: 10, backgroundColor: 'rgb(28, 28, 36)', borderRadius: 20, float: 'left'}}>{this.state.audio.schedule.genres[f]}</span>
												)
											})
										}
									</div>

								</div>
								<div className="text-right" style={{width:220, maxHeight:30, marginTop: 5}}>
									<ul className="p-icon-view">
										<li className="audio-cursor">
											<OverlayTrigger key="replay" placement="top" overlay={
													<Tooltip id="tooltip-replay">Replay Track</Tooltip>
												}><i className="fa fa-redo fa-flip-horizontal"></i>
											</OverlayTrigger>
										</li>
										<li className="audio-cursor">
											<OverlayTrigger key="restart" placement="top" overlay={
													<Tooltip id="tooltip-restart">Repeat Track</Tooltip>
												}><FontAwesomeIcon icon="repeat" />
											</OverlayTrigger></li>
										<li className="audio-cursor">
											<OverlayTrigger key="user" placement="top" overlay={
													<Tooltip id="tooltip-user">View DJ Profile</Tooltip>
												}><FontAwesomeIcon icon="user" />
											</OverlayTrigger>
										</li>
										<li className="audio-cursor">
											<OverlayTrigger key="favorite" placement="top" overlay={
													<Tooltip id="tooltip-favorite">Favorite</Tooltip>
												}><FontAwesomeIcon icon="heart" />
											</OverlayTrigger>
										</li>
										<li className="audio-cursor">
											<OverlayTrigger key="thumbs-up" placement="top" overlay={
													<Tooltip id="tooltip-thumbs-up">Thumbs Up</Tooltip>
												}><FontAwesomeIcon icon="thumbs-up" />
											</OverlayTrigger>
										</li>
										<li className="audio-cursor"><a href={`/audio/${this.state.audio.id}/${this.state.audio.showname}`}>
											<OverlayTrigger key="download" placement="top" overlay={
													<Tooltip id="tooltip-download">Download Track</Tooltip>
												}><FontAwesomeIcon icon="file-arrow-down" />
											</OverlayTrigger>
											</a>
										</li>
										<li className="audio-cursor">
											<OverlayTrigger key="edit" placement="top" overlay={
													<Tooltip id="tooltip-edit">Edit Track</Tooltip>
												}><FontAwesomeIcon icon="bars" />
											</OverlayTrigger>
										</li>
									</ul>
								</div>
								<div className="text-right" style={{width:160, maxHeight:30, marginTop: 5}}>
									<ul className="p-icon-view">
										<li><i className="fa fa-play"></i> 0</li>
										<li><i className="fa fa-heart"></i> 0</li>
										<li><i className="fa fa-thumbs-up"></i> 0</li>
									</ul>
								</div>
							</div>
						</div>
					</div>	
				</div>
				
			</div>
    );
  }
}